import PropTypes from "prop-types";
import TrackingRowsTable from "components/tracking/tracking-rows-table";

const TrackingPreview = ({ data }) => {
  return (
    <div>
      <h2 style={{ color: "#3498db" }}>
        {data?.importer_type} Import Preview -- Count: {data?.result?.length}
      </h2>
      {data.result.map((x) => (
        <div key={x[0]?.invoice_number} style={{ padding: 10 }}>
          <h5>{x[0]?.invoice_number}</h5>
          <TrackingRowsTable rows={x} />
        </div>
      ))}
    </div>
  );
};

TrackingPreview.propTypes = {
  data: PropTypes.shape({
    importer_type: PropTypes.string,
    fulfillment_company: PropTypes.string,
    result: PropTypes.arrayOf(PropTypes.object),
  }),
};

export default TrackingPreview;
